import { Container } from "./styles";

import profileImage from "../../assets/profile-image.jpg"
import cssIcon from "../../assets/css-icon.svg";
import htmlIcon from "../../assets/html-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import vueIcon from "../../assets/vue-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";


export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000}>
          <h2>About me</h2>
          <p>I am Sallam Tanna. I am a computer engineering graduate and I am a full-stack developer. I have been working with React and Node.js for 5 years. I worked on many projects locally and remotely with different clients, companies, and start-ups. I am also a retired UI designer, I would like to offer my help😎 </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <p>I have the following skills:</p>
        </ScrollAnimation>

        <div className="skills-div-container skills-divs">
          <ScrollAnimation animateIn="flipInX">
            <div className="skills-div">
              <strong>Front-end</strong>
              <li>HTML5, CSS5, JS, JQery</li>
              <li>React.js, Vue.js</li>
              <li>Redux & mobX</li>
              <li>Next.js</li>
              <li>TypeScript</li>
              <li>Ant-design, Material-UI , React-bootstrap</li>
              <li>Tailwind</li>
              <li>Gatsby</li>
            </div>
          </ScrollAnimation>

          <ScrollAnimation animateIn="flipInX">
            <div className="skills-div">
              <strong>Back-end</strong>
              <li>Node.js</li>
              <li>Express.js, sails, Nest.js</li>
              <li>REST API</li>
              <li>AWS</li>
              <li>GCP</li>
              <li>OAuth2, JWT, 2FA</li>
              <li>Salesforce</li>
            </div>
          </ScrollAnimation>

          <ScrollAnimation animateIn="flipInX">
            <div className="skills-div">
              <strong>Database</strong>
              <li>PostgreSQL</li>
              <li>MySQL</li>
              <li>MongoDB</li>
              <li>Firebase</li>
            </div>
          </ScrollAnimation>

          <ScrollAnimation animateIn="flipInX">
            <div className="skills-div">
              <strong>Others</strong>
              <li>Postman, swagger</li>
              <li>Test: Mocha, Jest, and Enzyme</li>
              <li><a target="_blank" className="skill-link" href="https://www.behance.net/sallamtannce39/projects" rel="noreferrer">Sketch, Figma, Adobe XD</a></li>
              <li>Jira, Slack, Notion, Trello, MS teams</li>
              <li>GIT, GitHub, GitLab</li>
            </div>
          </ScrollAnimation>
        </div>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.7 * 1000}>
          <h3>I am self, fast learner. I am keen to learn new things that the projects need to deliver a satisfying product.
          </h3>
        </ScrollAnimation>
      </div>
    </Container>
  )
}
